import {ChangeDetectionStrategy, Component, computed, inject, input} from '@angular/core';
import {AppNumberPipe, formatAppNumber} from '@frontend/shared';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {RfpCriterionResult} from '../../rfp-individual-results.types';

@Component({
  selector: 'app-rfp-sub-criteria-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe, ScoreBarComponent],
  host: {class: 'flex flex-col gap-3'},
  templateUrl: './rfp-sub-criteria-list.component.html',
})
export class RfpSubCriteriaListComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly criterion = input.required<RfpCriterionResult>();

  protected readonly hasFieldAverage = computed(() => this.criterion().fieldAverage !== null);
  protected readonly fieldAverageParams = computed(() => ({
    average: formatAppNumber(
      this.criterion().fieldAverage,
      this.translocoService.getActiveLang(),
      '1.0-0',
    ),
  }));
}
